import {
  LOCAL_LOG_BEARER,
  LOCAL_LOG_EMAIL,
  LOCAL_LOG_JWT,
  LOCAL_LOG_MAX_MESSAGE,
  LOCAL_LOG_SECRET_KEY,
  LOCAL_LOG_SECRET_ASSIGNMENT,
  LOCAL_LOG_URL_QUERY,
} from "../const/local-logs";

// Bound object traversal as well as the final text. Logging must tolerate cycles,
// BigInt, browser objects, and throwing getters without breaking the application.
export function serializeLocalLog(args: unknown[]): string {
  const seen = new WeakSet<object>();
  const snapshot = (value: unknown, depth: number): unknown => {
    if (typeof value === "string")
      return value
        .replace(LOCAL_LOG_BEARER, "Bearer [redacted]")
        .replace(LOCAL_LOG_JWT, "[redacted]")
        .replace(LOCAL_LOG_SECRET_ASSIGNMENT, "$1[redacted]")
        .replace(LOCAL_LOG_URL_QUERY, "$1?[redacted]")
        .replace(LOCAL_LOG_EMAIL, "[redacted email]")
        .slice(0, LOCAL_LOG_MAX_MESSAGE);
    if (typeof value === "bigint" || typeof value === "symbol" || typeof value === "function") return String(value);
    if (!value || typeof value !== "object") return value;
    if (seen.has(value)) return "[Circular]";
    if (depth > 3) return "[Object]";
    seen.add(value);
    if (value instanceof Error)
      return { name: value.name, message: snapshot(value.message, depth + 1), stack: snapshot(value.stack, depth + 1) };
    if (Array.isArray(value)) return value.slice(0, 20).map((item) => snapshot(item, depth + 1));
    const result: Record<string, unknown> = {};
    for (const key of Object.keys(value).slice(0, 20)) {
      result[key] = LOCAL_LOG_SECRET_KEY.test(key)
        ? "[redacted]"
        : snapshot((value as Record<string, unknown>)[key], depth + 1);
    }
    return result;
  };
  try {
    return args
      .slice(0, 20)
      .map((arg) => {
        const value = snapshot(arg, 0);
        return typeof value === "string" ? value : JSON.stringify(value) ?? String(value);
      })
      .join(" ")
      .slice(0, LOCAL_LOG_MAX_MESSAGE);
  } catch {
    return "[Unable to serialize console arguments]";
  }
}
